export const SDK_CSS = `
:root {
  --b-100: #F2F3F7;
  --s-700: #37546D;
}

.woot-widget-holder {
  box-shadow: 0 5px 40px rgba(0, 0, 0, .16);
  border: 1px solid rgba(227, 227, 227, 1);
  opacity: 1;
  will-change: transform, opacity;
  transform: translateY(0);
  overflow: hidden !important;
  position: fixed !important;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out, height 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  z-index: 2147483000 !important;
}

.woot-widget-holder.woot-widget-holder--flat {
  box-shadow: none;
  border-radius: 0;
  border: 1px solid var(--b-100);
}

.woot-widget-holder iframe {
  border: 0;
  height: 100% !important;
  width: 100% !important;
  max-height: 100vh !important;
}

.woot-widget-holder.has-unread-view {
  border-radius: 0 !important;
  min-height: 80px !important;
  height: auto;
  bottom: 94px;
  box-shadow: none !important;
  border: 0;
}

.woot-widget-bubble {
  background: #1f93ff;
  border-radius: 100px;
  border-width: 0px;
  bottom: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .16) !important;
  cursor: pointer;
  height: 60px;
  padding: 0px;
  position: fixed;
  user-select: none;
  width: 60px;
  z-index: 2147483000 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 150ms ease-in-out, box-shadow 150ms ease-in-out;
}

/* Icon wrapper base styles */
.woot-widget-bubble__icon {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
}

/* Reset SVG styles inside icon wrappers */
.woot-widget-bubble__icon svg {
  all: revert;
  height: 28px;
  width: 28px;
  margin: 0;
}

/* Chat icon - visible by default */
.woot-widget-bubble__chat-icon {
  opacity: 1;
  transform: scale(1) rotate(0deg);
}

/* Close icon - hidden by default */
.woot-widget-bubble__close-icon {
  opacity: 0;
  transform: scale(0) rotate(-180deg);
}

/* When widget is OPEN - swap icon visibility */
.woot-widget-bubble.woot--open .woot-widget-bubble__chat-icon {
  opacity: 0;
  transform: scale(0) rotate(180deg);
}

.woot-widget-bubble.woot--open .woot-widget-bubble__close-icon {
  opacity: 1;
  transform: scale(1) rotate(0deg);
}

/* Expanded bubble: chat icon should only fade, no rotate/scale (has text inside) */
.woot-widget-bubble.woot-widget--expanded .woot-widget-bubble__chat-icon {
  transform: none;
  transition: opacity 200ms ease-out;
}

.woot-widget-bubble.woot-widget--expanded.woot--open .woot-widget-bubble__chat-icon {
  opacity: 0;
  transform: none;
}

/* Lighter color variant - icon fill adjustment */
.woot-widget-bubble.woot-widget-bubble-color--lighter .woot-widget-bubble__icon path {
  fill: currentColor;
}

.woot-widget-bubble.woot-widget-bubble--flat {
  border-radius: 0;
}

.woot-widget-holder.woot-widget-holder--flat {
  bottom: 90px;
}

.woot-widget-bubble.woot-widget-bubble--flat {
  height: 56px;
  width: 56px;
}



.woot-widget-bubble.unread-notification::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  background: #ff4040;
  border-radius: 100%;
  top: 0px;
  right: 0px;
  border: 2px solid #ffffff;
  transition: background 0.2s ease;
}

.woot-widget-bubble.woot-widget--expanded {
  bottom: 20px;
  display: flex;
  height: 60px !important;
  align-items: center;
  overflow: hidden;
  transition: width 300ms cubic-bezier(0.25, 1, 0.5, 1), transform 150ms ease-in-out, box-shadow 150ms ease-in-out;
}

/* Chat icon wrapper in expanded bubble - needs relative position for text */
.woot-widget-bubble.woot-widget--expanded .woot-widget-bubble__chat-icon {
  position: relative;
  padding: 0 16px;
}

/* Text container inside expanded bubble */
.woot-widget-bubble.woot-widget--expanded #woot-widget--expanded__text {
  color: #fff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 200ms ease-out;
}

/* Text fades out when widget is open */
.woot-widget-bubble.woot-widget--expanded.woot--open #woot-widget--expanded__text {
  opacity: 0;
}

.woot-widget-bubble.woot-widget--expanded.woot-widget-bubble-color--lighter #woot-widget--expanded__text {
  color: inherit;
}

/* SVG in expanded chat icon */
.woot-widget-bubble.woot-widget--expanded .woot-widget-bubble__chat-icon svg {
  height: 20px;
  width: 20px;
  margin-right: 4px;
}

.woot-widget-bubble.woot-elements--left {
  left: 20px;
}

.woot-widget-bubble.woot-elements--right {
  right: 20px;
}

.woot-widget-bubble:hover {
  background: #1f93ff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, .4) !important;
  transform: scale(1.05);
}

.woot-widget-bubble:active {
  transform: scale(1.03);
}


.woot-widget-bubble.woot-widget-bubble-color--lighter path{
  fill: currentColor;
}

@media only screen and (min-width: 667px) {
  .woot-widget-holder.woot-elements--left {
    left: 20px;
 }
  .woot-widget-holder.woot-elements--right {
    right: 20px;
 }
}


.woot--hide {
  opacity: 0;
  visibility: hidden !important;
  z-index: -1 !important;
}

.woot-widget--without-bubble {
  bottom: 20px !important;
}

.woot-widget-holder.woot--hide {
  transform: translateY(16px);
  transition: opacity 0.15s ease-in, transform 0.15s ease-in, visibility 0s 0.15s;
}

@media only screen and (max-width: 667px) {
  .woot-widget-holder {
    height: 100%;
    right: 0;
    top: 0;
    width: 100%;
 }

 .woot-widget-holder iframe {
    min-height: 100% !important;
  }


 .woot-widget-holder.has-unread-view {
    height: auto;
    right: 0;
    width: auto;
    bottom: 0;
    top: auto;
    max-height: 100vh;
    padding: 0 8px;
  }

  .woot-widget-holder.has-unread-view iframe {
    min-height: unset !important;
  }

 .woot-widget-holder.has-unread-view.woot-elements--left {
    left: 0;
  }

  /* Hide bubble when widget is open on mobile */
  .woot-widget-bubble.woot--open {
    display: none !important;
  }
}

@media only screen and (min-width: 667px) {
  .woot-widget-holder {
    border-radius: 16px;
    bottom: 104px;
    height: calc(90% - 64px - 20px);
    max-height: 640px !important;
    min-height: 250px !important;
    width: 400px !important;
 }

  /* Dynamic height mode - height is set via JS */
  .woot-widget-holder.woot-widget-holder--dynamic-height {
    height: auto;
  }
}

.woot-hidden {
  display: none !important;
}
`;

export const widgetGradient = color =>
  `linear-gradient(161deg, #F4F3F5 8.3%, #F4F3F5 25.01%, #F4F3F5 58.1%, ${color} 94.45%)`;
